const minutesOf = time => {
  const [hours, minutes] = (time || "").split(":").map(Number)
  return hours * 60 + minutes
}

// A slot spanning the day carries the lunch break, a half day does not.
const LUNCH_SPAN_MINUTES = 5 * 60

// Mirrors ProjectAssignment#hours so an optimistic chip shows the right figure.
export const estimateHours = (attrs, settings) => {
  if (attrs.planned_hours) return Number(attrs.planned_hours)
  if (attrs.starts_at && attrs.ends_at) {
    const span    = minutesOf(attrs.ends_at) - minutesOf(attrs.starts_at)
    const minutes = span - (span > LUNCH_SPAN_MINUTES ? settings.break_minutes || 0 : 0)
    if (minutes > 0) return Math.round(minutes / 6) / 10
  }
  return settings.hours_per_day
}

export const formatHours = value => {
  const rounded = Math.round((value || 0) * 100) / 100
  const text = Number.isInteger(rounded) ? String(rounded) : rounded.toLocaleString(I18n.locale || "fr", { maximumFractionDigits: 2 })
  return I18n.t("project_planning.hours_short", { hours: text })
}

export const sumHours = items => items.reduce((total, item) => total + (item.hours || 0), 0)
